import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',

    padding: 40,
    paddingBottom: 70,
    backgroundColor: 'white',
  },

  fullWidthContainer: {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
  },

  pageTitle: {
    alignSelf: 'flex-start',
    fontSize: 36,
    fontWeight: 700,
    fontFamily: 'Lato',
    textTransform: 'uppercase',
    color: 'black',
  },

  galleryContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 8,
    width: '100%',
  },

  speakerItemWrapper: {
    flexDirection: 'row',

    borderRadius: 5,
    marginBottom: 10,
    overflow: 'hidden',

    width: 220,
    height: 130,
  },
  leftColumn: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 5,

    width: 80,
    minWidth: 80,

    border: '3px solid #ededed',
    borderRadius: 5,
  },
  rightColumn: {
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 8,
    gap: 4,
  },

  speakerImage: {
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,

    height: 78,
    width: 77,
    minWidth: 77,
    objectFit: 'cover',
  },
  companyLogoImage: {
    objectFit: 'contain',
    width: 77,
    height: 50,
    padding: 4,
  },

  speakerNameText: {
    flexWrap: 'wrap',
    fontSize: 12,
    fontWeight: 700,
    fontFamily: 'Lato',
    marginBottom: 8,
  },
  speakerCompanyText: {
    flexWrap: 'wrap',
    fontSize: 12,
    fontWeight: 400,
    fontFamily: 'Lato',
  },
  speakerJobTitleText: {
    flexWrap: 'wrap',
    fontSize: 12,
    fontWeight: 400,
    fontFamily: 'Lato',
  },
});
